import React, { useEffect, useMemo, useState } from 'react'
import { EditCartItemProps, SipValidationType } from '../types'
import { Box, Grid, useTheme } from '@mui/material'
import { Formik, useFormik } from 'formik';
import { SipScheme } from './Scheme';
import dayjs from 'dayjs';
import { getMandatesList } from '../../../redux-store/actions/investorProfile';
import { MandateListItem, MandatesListResBody } from '../../../redux-store/types/investorProfile';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import { MpowerValidationType } from '../../investorOverview/types';
import { InvestmentFundType } from '../../../redux-store/types/api-types';
import { formatCurrency } from '../../../utils/utilityFunctions';
import { CustomeBlueDatePicker, CustomeBlueDropDown, CustomeModalButton, CustomeNumberInput } from '../../investorOverview/transcation/FromInput';
import { WEEKLYDAYS } from '../../../utils/constant';

type Props = {
    data: EditCartItemProps
    currentTransactionType: string
    validation: SipValidationType,
    folio: string[]
    schemeLoading: boolean
    scheme: InvestmentFundType

}

export const handleDateValidation = (ArrayOfDate: Array<string | number>, date: dayjs.Dayjs) => {

    if (ArrayOfDate?.length === 0) {
        return false
    }
    if (typeof ArrayOfDate?.[0] === 'number') {
        return !ArrayOfDate?.includes(dayjs(date).date());
    }

    if (typeof ArrayOfDate?.[0] === 'string') {
        const capitalizedDays = ArrayOfDate.map(day =>
            day.toString().charAt(0) + day.toString().slice(1).toLowerCase()
        );
        const day = capitalizedDays.map(item => WEEKLYDAYS.indexOf(item))
        return !day?.includes(dayjs(date).day());
    }
    return false
}

export default function Sip(props: Props) {
    const theme = useTheme()
    const dispatch = useDispatch()

    const { investorClientId } = useSelector((store: RootStateType) => store.id)
    const { data, currentTransactionType, validation, folio, schemeLoading, scheme } = props
    const { onSave, sipAmount, frequency, onCancel, noOfInstallments, sipDate, mandate, isLoading, activeCategory, folioNumber } = data
    const [activeMandateList, setActiveMandateList] = useState<MandateListItem[]>([]);

    // sheme
    const schemeValidation = SipScheme({ scheme, sipAmount, frequency, noOfInstallments, sipDate, activeCategory, mandate })
    const { selectedPortfolio } = useSelector((state: RootStateType) => state.selectedPortfiolio)
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);




    useEffect(() => {
        const fetch = async () => {
            if (investorClientId) {
                const list = await (dispatch(getMandatesList({ clientCode: investorClientId, status: "Active", portfolioId: selectedPortfolio?.value })) as unknown as Promise<MandatesListResBody>);
                setActiveMandateList(list?.mandates ?? list ?? []);
            }
        }
        fetch();
    }, [investorClientId])

    function drowDownDateFormate(array: Array<MandateListItem>) {
        return array?.map((item: MandateListItem) => {
            return {
                label: item?.displayText,
                value: item?.mandateId
            }
        })
    }



    // handleSubmit
    function handleSubmitBtn(formValues: any) {
        formValues.sipDate = dayjs(formValues.sipDate).format('DD/MM/YYYY')
        onSave(
            data.id,
            currentTransactionType,
            {
                amount: formValues.sipAmount,
                frequency: formValues.frequency,
                noOfInstallment: formValues.noOfInstallments,
                sipDate: formValues.sipDate,
                mandateId: formValues.mandates,
                ...(activeCategory === "New Purchase" ? { folio: formValues.folios } : {})
            }
        )
    }

    const frequencyArray = scheme?.frequencies?.filter(item => item.frequency && item.tranasactionType === 'SIP')
    const Daily = scheme?.validations?.filter((item) => item?.frequency === 'DAILY' && item?.transactionType === 'SIP')?.[0]
    const Weekly = scheme?.validations?.filter((item) => item?.frequency === 'WEEKLY' && item?.transactionType === 'SIP')?.[0]
    const WeeklyDays = scheme?.validations?.filter((item) => item?.frequency === 'WEEKLYDAYS' && item?.transactionType === 'SIP')?.[0]
    const Monthly = scheme?.validations?.filter((item) => item?.frequency === 'MONTHLY' && item?.transactionType === 'SIP')?.[0]
    const Quarterly = scheme?.validations?.filter((item) => item?.frequency === 'QUARTERLY' && item?.transactionType === 'SIP')?.[0]
    const Yearly = scheme?.validations?.filter((item) => item?.frequency === 'YEARLY' && item?.transactionType === 'SIP')?.[0]

    const sipMinAmount = (key = 'minimumInstallmentAmount' as keyof MpowerValidationType, frequency: string) => {

        if (frequency === 'WEEKLY') {
            return Weekly?.[key]
        } else if (frequency === 'MONTHLY') {
            return Monthly?.[key]
        } else if (frequency === 'QUARTERLY') {
            return Quarterly?.[key]
        } else if (frequency === 'YEARLY') {
            return Yearly?.[key]
        } else if (frequency === 'DAILY') {
            return Daily?.[key]
        } else if (frequency === 'WEEKLYDAYS') {
            return WeeklyDays?.[key]
        } else {
            return 0
        }
    }

    return (
        <Formik
            enableReinitialize
            initialValues={{
                sipAmount: sipAmount || '0',
                frequency: frequency || '',
                noOfInstallments: noOfInstallments || '0',
                sipDate: dayjs(sipDate, 'DD/MM/YYYY') || '',
                mandates: mandate || '',
                ...(activeCategory === "New Purchase" ? { folios: folioNumber } : {})
            }}
            validationSchema={schemeValidation}
            onSubmit={handleSubmitBtn}>

            {(formik) => (
                <Box component={'form'} onSubmit={formik.handleSubmit} noValidate>

                    <Grid container spacing={2}>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomeNumberInput
                                isLoading={schemeLoading}
                                disable={isLoading}
                                textType="number"
                                label='SIP Amount'
                                name={`sipAmount`}
                                defaultValue={`${sipAmount}`}
                                minlabel={`Min:${formatCurrency({ value: Number(sipMinAmount('minimumInstallmentAmount', formik.values.frequency) ?? 0), locale, currencyCode })}`}
                                removeIcons={true}
                                warningText={'amount'}
                            />
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomeBlueDropDown
                                name={`frequency`}
                                disabled={isLoading}
                                isLoading={schemeLoading}
                                label='Frequency'
                                list={frequencyArray?.map(item => ({ value: item.frequency, label: item.frequency })) as any}
                            />
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomeNumberInput
                                isLoading={schemeLoading}
                                disable={isLoading}
                                textType="number"
                                label='No. of Installments'
                                name={`noOfInstallments`}
                                defaultValue={`${noOfInstallments}`}
                                minValue={sipMinAmount('minimumInstallments', formik.values.frequency)}
                                removeIcons={true}
                            />
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomeBlueDatePicker
                                disabled={isLoading}
                                name={`sipDate`}
                                isLoading={schemeLoading}
                                disablePast={true}
                                // disableDateList={getValidation?.investmentDates}
                                shouldDisableDate={(date: dayjs.Dayjs) => handleDateValidation(sipMinAmount('investmentDates', formik.values.frequency) || [], date)}
                                minDate={dayjs().add(1, 'day')}
                            />
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12} sx={{ paddingBottom: "20px" }}>
                            <CustomeBlueDropDown
                                name={`mandates`}
                                isLoading={schemeLoading}
                                disabled={isLoading}
                                label='Mandate'
                                list={drowDownDateFormate(activeMandateList)}
                            />
                        </Grid>
                        {activeCategory === "New Purchase" &&
                            <Grid item lg={6} md={6} sm={12} xs={12} sx={{ paddingBottom: "20px" }}>
                                <CustomeBlueDropDown
                                    isLoading={schemeLoading}
                                    // disabled={isLoading}
                                    disabled
                                    label='Select Folio'
                                    name={'folios'}
                                    list={folio?.map((item: string) => ({ label: item, value: item }))}
                                />
                            </Grid>
                        }
                        <Grid
                            item
                            container
                            xs={12}
                            mt={2}
                            sx={{
                                justifyContent: "center",
                                alignItems: "center",
                                borderTop: `0.5px solid ${theme.palette.text.secondary}B2`
                            }}
                        >
                            <Grid
                                item
                                container
                                xs={9.5}
                                sx={{
                                    columnGap: "35px",
                                    flexWrap: "nowrap",
                                    paddingTop: "30px",
                                }}
                            >
                                <Grid
                                    item
                                    xs={6}
                                >
                                    <CustomeModalButton
                                        disabled={isLoading || schemeLoading}
                                        onClick={() => onCancel()}
                                        btnText='Cancel'
                                        variant='outlined'
                                        boxStyle={{
                                            color: theme.palette.text.primary,
                                        }}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={6}
                                >
                                    <CustomeModalButton
                                        variant='contained'
                                        disabled={!formik.dirty || schemeLoading}
                                        isLoading={isLoading}
                                        btnText='Save Changes'
                                        type='submit'
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            )}

        </Formik>
    )
}